import { GridCellParams } from '@mui/x-data-grid-pro';
import { AssessmentMethodType } from '@schooly/api';
import {
  createFieldKey,
  createFieldKeyConfig,
  createFieldKeyFromArray,
  parseFieldKey,
} from '@schooly/components/data-grid';

import { AVERAGE_COL_FIELD_KEY } from './assessmentStyling';

export const assessmentFieldConfig = createFieldKeyConfig('students');

export type MarkbookForGroupFieldKeyComponents = {
  assessmentId: string;
  methodType: AssessmentMethodType;
  assessmentIndex: number;
  methodIndex: number;
};

export const createMarkbookForGroupFieldKey = ({
  assessmentId,
  methodType,
  assessmentIndex,
  methodIndex,
}: MarkbookForGroupFieldKeyComponents): string => {
  return createFieldKey(
    {
      id: assessmentId,
      type: methodType.toString(),
      idIndex: assessmentIndex,
      typeIndex: methodIndex,
    },
    assessmentFieldConfig,
  );
};

export const parseMarkbookForGroupFieldKey = (
  field: GridCellParams['field'],
): MarkbookForGroupFieldKeyComponents | null => {
  const parsed = parseFieldKey(field, assessmentFieldConfig);
  if (!parsed) return null;

  return {
    assessmentId: parsed.id,
    methodType: parseInt(parsed.type) as AssessmentMethodType,
    assessmentIndex: parsed.idIndex,
    methodIndex: parsed.typeIndex,
  };
};

export type MarkbookForGroupsFieldKeyComponents = {
  assessmentId: string;
  subjectId: string;
  methodType: AssessmentMethodType;
};

export const createMarkbookForGroupsMethodFieldKey = ({
  assessmentId,
  subjectId,
  methodType,
}: MarkbookForGroupsFieldKeyComponents): string => {
  return createFieldKeyFromArray([assessmentId, subjectId, methodType.toString()]);
};

export const createMarkbookForGroupsAverageFieldKey = ({
  subjectId,
}: {
  subjectId: string;
}): string => {
  return `${subjectId}-${AVERAGE_COL_FIELD_KEY}`;
};
